// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/AdminPortal/Business/Center.css */

.business-center-container {
    padding: 22px;
    margin: 0 auto;
    min-height: calc(100vh - 12vh);
    background:
        linear-gradient(180deg, #f6f9fc 0%, #ffffff 42%),
        radial-gradient(circle at 8% 0%, rgba(239, 111, 83, 0.12), transparent 28%);
    color: #243447;
}

.center-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 22px;
    padding: 18px 20px;
    border: 1px solid rgba(54, 76, 99, 0.1);
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 14px 34px rgba(54, 76, 99, 0.1);
}

.center-header h2 {
    margin: 0;
    color: #243447;
    font-size: 1.8rem;
    line-height: 1.15;
    text-transform: uppercase;
    position: relative;
    text-align: center;
    padding-bottom: 10px;
    letter-spacing: 0;
    font-weight: 900;
    overflow-wrap: anywhere;
}

.center-header h2::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(
        to right,
        #EF6F53 0%,
        #EF6F53 40%,
        #1976d2 40%,
        #1976d2 60%,
        #EF6F53 60%,
        #EF6F53 100%
    );
}

.add-team-button {
    background: linear-gradient(135deg, #EF6F53, #d85a41);
    color: white;
    border: none;
    padding: 8px 14px;
    border-radius: 7px;
    cursor: pointer;
    font-size: 0.92rem;
    font-weight: 800;
    box-shadow: 0 10px 22px rgba(239, 111, 83, 0.26);
    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;
    white-space: nowrap;
}

.add-team-button:hover:not(:disabled) {
    filter: brightness(1.03);
    transform: translateY(-2px);
    box-shadow: 0 14px 28px rgba(239, 111, 83, 0.32);
}


.teams-section {
    margin-top: 15px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #90A4AE #CFD8DC;
}

.teams-section::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.teams-section::-webkit-scrollbar-track {
    background: #CFD8DC;
    border-radius: 4px;
}

.teams-section::-webkit-scrollbar-thumb {
    background-color: #90A4AE;
    border-radius: 4px;
}

.teams-section::-webkit-scrollbar-thumb:hover {
    background-color: #78909C;
}

.teams-section h3 {
    color: #0b4267f4; 
    font-size:22px;
    margin-bottom: 5px;
}

.teams-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    margin-bottom: 20px;
}

.team-card {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transition: transform 0.2s;
}

.team-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.team-header h3 {
    margin: 0 0 15px 0;
    color: #EF6F53;
    font-size: 18px;
    border-bottom: 1px solid #EF6F53;
}

.teams-pagination {
    text-align: right;
    color: #666;
    margin-top: 20px;
}

.sectionnnnn {
    background: white;
    border-radius: 8px;
    padding: 14px;
    border: 1px solid rgba(54, 76, 99, 0.1);
    box-shadow: 0 14px 34px rgba(54, 76, 99, 0.1);
    margin-bottom: 2rem;
}

.create-team-heading {
    color: #243447;
    font-size: 1.2rem;
    margin-bottom: 1rem;
    font-weight: 900;
    text-align: center;
}

.team-inputtt {
    background: #f8fafc;
    padding: 14px;
    border: 1px solid rgba(25, 118, 210, 0.1);
    border-radius: 8px;
    margin: auto;
    width: 100%;
}

.form-rowww {
    display: flex;
    margin-bottom: 5px;
    width: 100%;
}

.form-groupppp {
    flex: 1 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
}

.form-groupppp label {
    font-size: 14px;
    font-weight: 500;
    color: #2c3e50;
    min-width: 120px;
    text-align: right;
}

.form-groupppp .input-container {
    flex: 1 1;
    display: flex;
    position: relative;
}

.form-groupppp input,
.form-groupppp textarea {
    border: 1px solid #ddd;
    border-radius: 7px;
    font-size: 12px;
    width: 100%;
    padding: 7px 9px;
    background: #ffffff;
    transition: border-color 160ms ease, box-shadow 160ms ease;
}

.form-groupppp textarea {
    resize: vertical;
    min-height: 60px;
}

.form-groupppp input:focus,
.form-groupppp textarea:focus {
    outline: none;
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.team-row {
    display: flex;
    gap: 5px;
    margin-bottom: 5px;
}

.team-row input {
    padding: 5px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
}

.team-row input:focus {
    outline: none;
    border-color: #4CAF50;
}

.first-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}

.second-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.third-row {
    display: grid;
    grid-template-columns: 3fr 1fr;
}

.fourth-row,
.fifth-row {
    display: grid;
    grid-template-columns: 1fr;
}

@media (max-width: 768px) {
    .first-row,
    .second-row,
    .third-row {
        grid-template-columns: 1fr;
        gap: 10px;
    }
}

.create-button {
    background-color: #3498db;
    color: white;
    border: none;
    padding: 2px 5px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;
}

.create-button:hover {
    background-color: #45a049;
}

/* .message-container {
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 15px 25px;
    border-radius: 5px;
    color: white;
    animation: slideIn 0.3s ease-out;
} */


@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.business-name {
    color: #364C63;
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    text-transform: uppercase;
    border-bottom: 3px solid #EF6F53;
    display: inline-block;
    position: relative;
}

.section {
    background: white;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 2rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form {
    background-color: #f8f9fa;
    padding: 1rem;
    border-radius: 8px;
    margin-bottom: 1rem;
}

.form-row {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
}

.form-group {
    flex: 1 1;
    display: flex;
    flex-direction: column;
}

.form-group.full-width {
    flex: 2 1;
}

.form-group label {
    margin-bottom: 0.5rem;
    color: #364C63;
    font-weight: 500;
}

.form-group input,
.form-group textarea {
    padding: 0.5rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 1rem;
}

.form-group textarea {
    resize: vertical;
    min-height: 100px;
}

.form-actionss {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
}

.form-actionss button {
    background: #24516f;
    color: white;
    border: none;
    padding: 7px 14px;
    border-radius: 7px;
    cursor: pointer;
    font-weight: 500;
    font-size: 15px;
    transition: transform 160ms ease, filter 160ms ease;
}

.form-actionss button:hover {
    transform: translateY(-2px);
    filter: brightness(1.06);
}

.form-actionss button:last-child {
    background: #eef2f6;
    color: #364C63;
    border: 1px solid rgba(54, 76, 99, 0.16);
}

.cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1rem;
    margin-top: 1rem;
}

.card {
    background: white;
    border-radius: 8px;
    padding: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s, box-shadow 0.3s;
}

.card:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.card h3 {
    color: #364C63;
    font-size: 1.2rem;
    margin-bottom: 1rem;
    border-bottom: 2px solid #EF6F53;
    padding-bottom: 0.5rem;
}

.card p {
    margin: 0.25rem 0;
    color: #4a5568;
}

.card strong {
    color: #2d3748;
}

.teams-list-section {
    background: #ffffff;
    border-radius: 8px;
    overflow-x: auto;
    border: 1px solid rgba(54, 76, 99, 0.1);
    box-shadow: 0 14px 34px rgba(54, 76, 99, 0.1);
    padding: 14px;
}

.teams-list-section h3 {
    color: #243447;
    font-size: 1.25rem;
    font-weight: 900;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    position: relative;
    margin: 0 0 14px;
    padding-bottom: 9px;
}

.teams-list-section h3::after,
.create-team-headingg::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 72px;
    height: 3px;
    border-radius: 999px;
    background: linear-gradient(90deg, #EF6F53, #1976d2);
    transform: translateX(-50%);
}

.teams-list-section::-webkit-scrollbar {
    height: 4px;
}

.teams-list-section::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
}

.teams-list-section::-webkit-scrollbar-thumb {
    background: #EF6F53;
    border-radius: 5px;
}

.teams-gridd {
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;
    padding: 6px 3px 12px;
    min-width: min-content;
}

.team-cardd {
    flex: 0 0 310px;
    background:
        linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    border-radius: 8px;
    padding: 14px;
    box-shadow: 0 10px 24px rgba(54, 76, 99, 0.11);
    transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;
    border: 1px solid rgba(25, 118, 210, 0.12);
    border-bottom: 3px solid #1976d2;
    position: relative;
    overflow: hidden;
}

.team-cardd::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #EF6F53, #1976d2);
}

.team-cardd:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 34px rgba(54, 76, 99, 0.16);
    border-color: rgba(239, 111, 83, 0.28);
}

.team-card-header {
    border-bottom: 1px solid rgba(25, 118, 210, 0.16);
    margin: 2px 0 0.65rem;
    padding-bottom: 0.5rem;
}

.team-card-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
}

.team-card-title-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    min-width: 0;
    flex: 1 1 auto;
}

.team-cardd h4 {
    color: #ffffff;
    margin: 0;
    font-size: 1.08rem;
    line-height: 1.25;
    font-weight: 900;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.team-card-extension {
    display: block;
    flex: 0 0 auto;
    margin-top: 0;
    color: #ffffff;
    font-size: 0.78rem;
    font-weight: 850;
    white-space: nowrap;
}

.team-extension-call-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    margin-left: auto;
    width: 34px;
    height: 34px;
    border: 1px solid rgba(255, 255, 255, 0.55);
    border-radius: 999px;
    background: linear-gradient(135deg, #00f5d4, #00bbf9 48%, #fee440);
    color: #102030;
    cursor: pointer;
    box-shadow: 0 10px 22px rgba(0, 187, 249, 0.28);
    transition: background 160ms ease, color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.team-extension-call-button:hover:not(:disabled) {
    background: linear-gradient(135deg, #ff006e, #fb5607);
    border-color: rgba(255, 255, 255, 0.78);
    color: #ffffff;
    box-shadow: 0 10px 24px rgba(255, 0, 110, 0.34);
}

.team-extension-call-button:disabled {
    cursor: not-allowed;
    background: rgba(255, 255, 255, 0.24);
    color: rgba(255, 255, 255, 0.68);
    box-shadow: none;
}

.team-detailss p {
    margin: 0.35rem 0;
    color: #364C63;
    font-size: 0.9rem;
    text-align: left;
    overflow-wrap: anywhere;
}

.team-detailss strong {
    margin-right: 5px;
    color: #24516f;
}

.team-associates-list {
    display: flex;
    flex-direction: column;
    gap: 7px;
    margin-top: 8px;
}

.team-associate-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 7px 8px;
    border: 1px solid rgba(54, 76, 99, 0.08);
    border-radius: 7px;
    background: #f8fafc;
}

.team-associate-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.team-associate-name {
    color: #243447;
    font-size: 0.9rem;
    font-weight: 900;
    overflow-wrap: anywhere;
}

.team-associate-extension {
    color: #66788f;
    font-size: 0.76rem;
    font-weight: 800;
}

.associate-call-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 30px;
    height: 30px;
    border: none;
    border-radius: 999px;
    background: linear-gradient(135deg, #1976d2, #24516f);
    color: #ffffff;
    cursor: pointer;
    box-shadow: 0 8px 16px rgba(25, 118, 210, 0.2);
    transition: transform 160ms ease, filter 160ms ease;
}

.associate-call-button:hover:not(:disabled) {
    filter: brightness(1.06);
    transform: translateY(-1px);
}

.associate-call-button:disabled {
    cursor: not-allowed;
    background: #a6adb7;
    color: #f4f6f8;
    opacity: 1;
    box-shadow: none;
}

.associate-call-button i {
    font-size: 0.82rem;
}

.team-associates-empty {
    padding: 8px;
    border: 1px dashed rgba(54, 76, 99, 0.22);
    border-radius: 7px;
    color: #66788f;
    background: #f8fafc;
    font-size: 0.84rem;
    font-weight: 800;
    text-align: center;
}

.teams-pagination {
    display: flex;
    justify-content: center;
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #f8f9fa;
    margin-top: 0.5rem;
    z-index: 1;
    margin-bottom: 0.25rem;
}

.teams-pagination span {
    color: #364C63;
    font-size: 0.95rem;
    font-weight: 800;
    background: #f8fafc;
    border: 1px solid rgba(54, 76, 99, 0.1);
    border-radius: 7px;
    box-shadow: none;
    padding: 5px 10px;
}

.team-actions {
    display: flex;
    gap: 10px;
    margin-top: 15px;
    justify-content: flex-end;
}

.team-actions button {
    padding: 7px 12px;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 800;
    transition: transform 160ms ease, filter 160ms ease;
}

.team-actions button:first-child {
    background: #24516f;
    color: white;
}

.team-actions button:first-child:hover {
    filter: brightness(1.06);
    transform: translateY(-1px);
}

.team-actions button:last-child {
    background-color: #e74c3c;
    color: white;
}

.team-actions button:last-child:hover {
    filter: brightness(1.04);
    transform: translateY(-1px);
}

.team-actions button:active {
    transform: scale(0.98);
}

@media (max-width: 768px) {
    .center-container {
        padding: 1rem;
    }

    .form-row {
        flex-direction: column;
        gap: 0.5rem;
    }

    .cards-container {
        grid-template-columns: 1fr;
    }

    .section {
        padding: 1rem;
    }
}

.ass-section {
    background-color: #ffffff;
    border-radius: 8px;
    margin-top: 2rem;
    border: 1px solid rgba(54, 76, 99, 0.1);
    box-shadow: 0 14px 34px rgba(54, 76, 99, 0.1);
    padding: 14px;
}

.create-team-headingg {
    color: #243447;
    font-size: 1.2rem;
    font-weight: 900;
    text-transform: uppercase;
    margin-top: 0;
    position: relative;
    padding-bottom: 9px;
}

.team-limit-warning {
    background-color: #fff3cd;
    color: #856404;
    padding: 10px 15px;
    border: 1px solid #ffeeba;
    border-radius: 4px;
    margin: 10px 0;
    text-align: center;
    font-weight: 500;
}

.button-containerr {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.button-containerr .create-button {
    background-color: #3498db;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;
}

.button-containerr .create-button:hover {
    background-color: #45a049;
}

.add-associate-buttonnn{
    background-color: #EF6F53;
    color: white;
    border: none;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;
    border-radius: 10px;
}

.add-associate-buttonnn:hover {
    background-color: #d15846;
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/AdminPortal/Business/Center.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;IACI,aAAa;IACb,cAAc;IACd,8BAA8B;IAC9B;;mFAE+E;IAC/E,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX;;;;;;;;KAQC;AACL;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gDAAgD;IAChD,0EAA0E;IAC1E,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,gDAAgD;AACpD;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,uCAAuC;IACvC,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,kBAAkB;AACtB;;AAEA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,0DAA0D;AAC9D;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI;;;QAGI,0BAA0B;QAC1B,SAAS;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;;;;;GAQG;;;AAGH;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,gCAAgC;IAChC,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;IACxC,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;IACvC,6CAA6C;IAC7C,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,oDAAoD;IACpD,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf;yDACqD;IACrD,kBAAkB;IAClB,aAAa;IACb,8CAA8C;IAC9C,gFAAgF;IAChF,0CAA0C;IAC1C,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,oDAAoD;AACxD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,sCAAsC;AAC1C;;AAEA;IACI,iDAAiD;IACjD,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,oBAAoB;IACpB,kEAAkE;IAClE,cAAc;IACd,eAAe;IACf,+CAA+C;IAC/C,mGAAmG;AACvG;;AAEA;IACI,qDAAqD;IACrD,uCAAuC;IACvC,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,qDAAqD;IACrD,cAAc;IACd,eAAe;IACf,8CAA8C;IAC9C,mDAAmD;AACvD;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;IACvC,6CAA6C;IAC7C,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* src/components/routes/Forms/AdminPortal/Business/Center.css */\n\n.business-center-container {\n    padding: 22px;\n    margin: 0 auto;\n    min-height: calc(100vh - 12vh);\n    background:\n        linear-gradient(180deg, #f6f9fc 0%, #ffffff 42%),\n        radial-gradient(circle at 8% 0%, rgba(239, 111, 83, 0.12), transparent 28%);\n    color: #243447;\n}\n\n.center-header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 22px;\n    padding: 18px 20px;\n    border: 1px solid rgba(54, 76, 99, 0.1);\n    border-radius: 8px;\n    background: #ffffff;\n    box-shadow: 0 14px 34px rgba(54, 76, 99, 0.1);\n}\n\n.center-header h2 {\n    margin: 0;\n    color: #243447;\n    font-size: 1.8rem;\n    line-height: 1.15;\n    text-transform: uppercase;\n    position: relative;\n    text-align: center;\n    padding-bottom: 10px;\n    letter-spacing: 0;\n    font-weight: 900;\n    overflow-wrap: anywhere;\n}\n\n.center-header h2::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background: linear-gradient(\n        to right,\n        #EF6F53 0%,\n        #EF6F53 40%,\n        #1976d2 40%,\n        #1976d2 60%,\n        #EF6F53 60%,\n        #EF6F53 100%\n    );\n}\n\n.add-team-button {\n    background: linear-gradient(135deg, #EF6F53, #d85a41);\n    color: white;\n    border: none;\n    padding: 8px 14px;\n    border-radius: 7px;\n    cursor: pointer;\n    font-size: 0.92rem;\n    font-weight: 800;\n    box-shadow: 0 10px 22px rgba(239, 111, 83, 0.26);\n    transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;\n    white-space: nowrap;\n}\n\n.add-team-button:hover:not(:disabled) {\n    filter: brightness(1.03);\n    transform: translateY(-2px);\n    box-shadow: 0 14px 28px rgba(239, 111, 83, 0.32);\n}\n\n\n.teams-section {\n    margin-top: 15px;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    scrollbar-color: #90A4AE #CFD8DC;\n}\n\n.teams-section::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n.teams-section::-webkit-scrollbar-track {\n    background: #CFD8DC;\n    border-radius: 4px;\n}\n\n.teams-section::-webkit-scrollbar-thumb {\n    background-color: #90A4AE;\n    border-radius: 4px;\n}\n\n.teams-section::-webkit-scrollbar-thumb:hover {\n    background-color: #78909C;\n}\n\n.teams-section h3 {\n    color: #0b4267f4; \n    font-size:22px;\n    margin-bottom: 5px;\n}\n\n.teams-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.team-card {\n    background: white;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    transition: transform 0.2s;\n}\n\n.team-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n.team-header h3 {\n    margin: 0 0 15px 0;\n    color: #EF6F53;\n    font-size: 18px;\n    border-bottom: 1px solid #EF6F53;\n}\n\n.teams-pagination {\n    text-align: right;\n    color: #666;\n    margin-top: 20px;\n}\n\n.sectionnnnn {\n    background: white;\n    border-radius: 8px;\n    padding: 14px;\n    border: 1px solid rgba(54, 76, 99, 0.1);\n    box-shadow: 0 14px 34px rgba(54, 76, 99, 0.1);\n    margin-bottom: 2rem;\n}\n\n.create-team-heading {\n    color: #243447;\n    font-size: 1.2rem;\n    margin-bottom: 1rem;\n    font-weight: 900;\n    text-align: center;\n}\n\n.team-inputtt {\n    background: #f8fafc;\n    padding: 14px;\n    border: 1px solid rgba(25, 118, 210, 0.1);\n    border-radius: 8px;\n    margin: auto;\n    width: 100%;\n}\n\n.form-rowww {\n    display: flex;\n    margin-bottom: 5px;\n    width: 100%;\n}\n\n.form-groupppp {\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 5px;\n}\n\n.form-groupppp label {\n    font-size: 14px;\n    font-weight: 500;\n    color: #2c3e50;\n    min-width: 120px;\n    text-align: right;\n}\n\n.form-groupppp .input-container {\n    flex: 1;\n    display: flex;\n    position: relative;\n}\n\n.form-groupppp input,\n.form-groupppp textarea {\n    border: 1px solid #ddd;\n    border-radius: 7px;\n    font-size: 12px;\n    width: 100%;\n    padding: 7px 9px;\n    background: #ffffff;\n    transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.form-groupppp textarea {\n    resize: vertical;\n    min-height: 60px;\n}\n\n.form-groupppp input:focus,\n.form-groupppp textarea:focus {\n    outline: none;\n    border-color: #3498db;\n    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\n}\n\n.team-row {\n    display: flex;\n    gap: 5px;\n    margin-bottom: 5px;\n}\n\n.team-row input {\n    padding: 5px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.team-row input:focus {\n    outline: none;\n    border-color: #4CAF50;\n}\n\n.first-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n}\n\n.second-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n}\n\n.third-row {\n    display: grid;\n    grid-template-columns: 3fr 1fr;\n}\n\n.fourth-row,\n.fifth-row {\n    display: grid;\n    grid-template-columns: 1fr;\n}\n\n@media (max-width: 768px) {\n    .first-row,\n    .second-row,\n    .third-row {\n        grid-template-columns: 1fr;\n        gap: 10px;\n    }\n}\n\n.create-button {\n    background-color: #3498db;\n    color: white;\n    border: none;\n    padding: 2px 5px;\n    border-radius: 10px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.3s;\n}\n\n.create-button:hover {\n    background-color: #45a049;\n}\n\n/* .message-container {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    padding: 15px 25px;\n    border-radius: 5px;\n    color: white;\n    animation: slideIn 0.3s ease-out;\n} */\n\n\n@keyframes slideIn {\n    from {\n        transform: translateX(100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n.business-name {\n    color: #364C63;\n    text-align: center;\n    font-size: 2rem;\n    font-weight: bold;\n    text-transform: uppercase;\n    border-bottom: 3px solid #EF6F53;\n    display: inline-block;\n    position: relative;\n}\n\n.section {\n    background: white;\n    border-radius: 8px;\n    padding: 1.5rem;\n    margin-bottom: 2rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.form {\n    background-color: #f8f9fa;\n    padding: 1rem;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n}\n\n.form-row {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1rem;\n}\n\n.form-group {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.form-group.full-width {\n    flex: 2;\n}\n\n.form-group label {\n    margin-bottom: 0.5rem;\n    color: #364C63;\n    font-weight: 500;\n}\n\n.form-group input,\n.form-group textarea {\n    padding: 0.5rem;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    font-size: 1rem;\n}\n\n.form-group textarea {\n    resize: vertical;\n    min-height: 100px;\n}\n\n.form-actionss {\n    display: flex;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n.form-actionss button {\n    background: #24516f;\n    color: white;\n    border: none;\n    padding: 7px 14px;\n    border-radius: 7px;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 15px;\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.form-actionss button:hover {\n    transform: translateY(-2px);\n    filter: brightness(1.06);\n}\n\n.form-actionss button:last-child {\n    background: #eef2f6;\n    color: #364C63;\n    border: 1px solid rgba(54, 76, 99, 0.16);\n}\n\n.cards-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 1rem;\n    margin-top: 1rem;\n}\n\n.card {\n    background: white;\n    border-radius: 8px;\n    padding: 1rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s, box-shadow 0.3s;\n}\n\n.card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.card h3 {\n    color: #364C63;\n    font-size: 1.2rem;\n    margin-bottom: 1rem;\n    border-bottom: 2px solid #EF6F53;\n    padding-bottom: 0.5rem;\n}\n\n.card p {\n    margin: 0.25rem 0;\n    color: #4a5568;\n}\n\n.card strong {\n    color: #2d3748;\n}\n\n.teams-list-section {\n    background: #ffffff;\n    border-radius: 8px;\n    overflow-x: auto;\n    border: 1px solid rgba(54, 76, 99, 0.1);\n    box-shadow: 0 14px 34px rgba(54, 76, 99, 0.1);\n    padding: 14px;\n}\n\n.teams-list-section h3 {\n    color: #243447;\n    font-size: 1.25rem;\n    font-weight: 900;\n    text-transform: uppercase;\n    display: flex;\n    justify-content: center;\n    position: relative;\n    margin: 0 0 14px;\n    padding-bottom: 9px;\n}\n\n.teams-list-section h3::after,\n.create-team-headingg::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    width: 72px;\n    height: 3px;\n    border-radius: 999px;\n    background: linear-gradient(90deg, #EF6F53, #1976d2);\n    transform: translateX(-50%);\n}\n\n.teams-list-section::-webkit-scrollbar {\n    height: 4px;\n}\n\n.teams-list-section::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 5px;\n}\n\n.teams-list-section::-webkit-scrollbar-thumb {\n    background: #EF6F53;\n    border-radius: 5px;\n}\n\n.teams-gridd {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 16px;\n    padding: 6px 3px 12px;\n    min-width: min-content;\n}\n\n.team-cardd {\n    flex: 0 0 310px;\n    background:\n        linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n    border-radius: 8px;\n    padding: 14px;\n    box-shadow: 0 10px 24px rgba(54, 76, 99, 0.11);\n    transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;\n    border: 1px solid rgba(25, 118, 210, 0.12);\n    border-bottom: 3px solid #1976d2;\n    position: relative;\n    overflow: hidden;\n}\n\n.team-cardd::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 4px;\n    background: linear-gradient(90deg, #EF6F53, #1976d2);\n}\n\n.team-cardd:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 18px 34px rgba(54, 76, 99, 0.16);\n    border-color: rgba(239, 111, 83, 0.28);\n}\n\n.team-card-header {\n    border-bottom: 1px solid rgba(25, 118, 210, 0.16);\n    margin: 2px 0 0.65rem;\n    padding-bottom: 0.5rem;\n}\n\n.team-card-title-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    width: 100%;\n}\n\n.team-card-title-text {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    min-width: 0;\n    flex: 1 1 auto;\n}\n\n.team-cardd h4 {\n    color: #ffffff;\n    margin: 0;\n    font-size: 1.08rem;\n    line-height: 1.25;\n    font-weight: 900;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.team-card-extension {\n    display: block;\n    flex: 0 0 auto;\n    margin-top: 0;\n    color: #ffffff;\n    font-size: 0.78rem;\n    font-weight: 850;\n    white-space: nowrap;\n}\n\n.team-extension-call-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    margin-left: auto;\n    width: 34px;\n    height: 34px;\n    border: 1px solid rgba(255, 255, 255, 0.55);\n    border-radius: 999px;\n    background: linear-gradient(135deg, #00f5d4, #00bbf9 48%, #fee440);\n    color: #102030;\n    cursor: pointer;\n    box-shadow: 0 10px 22px rgba(0, 187, 249, 0.28);\n    transition: background 160ms ease, color 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.team-extension-call-button:hover:not(:disabled) {\n    background: linear-gradient(135deg, #ff006e, #fb5607);\n    border-color: rgba(255, 255, 255, 0.78);\n    color: #ffffff;\n    box-shadow: 0 10px 24px rgba(255, 0, 110, 0.34);\n}\n\n.team-extension-call-button:disabled {\n    cursor: not-allowed;\n    background: rgba(255, 255, 255, 0.24);\n    color: rgba(255, 255, 255, 0.68);\n    box-shadow: none;\n}\n\n.team-detailss p {\n    margin: 0.35rem 0;\n    color: #364C63;\n    font-size: 0.9rem;\n    text-align: left;\n    overflow-wrap: anywhere;\n}\n\n.team-detailss strong {\n    margin-right: 5px;\n    color: #24516f;\n}\n\n.team-associates-list {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n    margin-top: 8px;\n}\n\n.team-associate-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 7px 8px;\n    border: 1px solid rgba(54, 76, 99, 0.08);\n    border-radius: 7px;\n    background: #f8fafc;\n}\n\n.team-associate-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.team-associate-name {\n    color: #243447;\n    font-size: 0.9rem;\n    font-weight: 900;\n    overflow-wrap: anywhere;\n}\n\n.team-associate-extension {\n    color: #66788f;\n    font-size: 0.76rem;\n    font-weight: 800;\n}\n\n.associate-call-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    width: 30px;\n    height: 30px;\n    border: none;\n    border-radius: 999px;\n    background: linear-gradient(135deg, #1976d2, #24516f);\n    color: #ffffff;\n    cursor: pointer;\n    box-shadow: 0 8px 16px rgba(25, 118, 210, 0.2);\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.associate-call-button:hover:not(:disabled) {\n    filter: brightness(1.06);\n    transform: translateY(-1px);\n}\n\n.associate-call-button:disabled {\n    cursor: not-allowed;\n    background: #a6adb7;\n    color: #f4f6f8;\n    opacity: 1;\n    box-shadow: none;\n}\n\n.associate-call-button i {\n    font-size: 0.82rem;\n}\n\n.team-associates-empty {\n    padding: 8px;\n    border: 1px dashed rgba(54, 76, 99, 0.22);\n    border-radius: 7px;\n    color: #66788f;\n    background: #f8fafc;\n    font-size: 0.84rem;\n    font-weight: 800;\n    text-align: center;\n}\n\n.teams-pagination {\n    display: flex;\n    justify-content: center;\n    position: sticky;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: #f8f9fa;\n    margin-top: 0.5rem;\n    z-index: 1;\n    margin-bottom: 0.25rem;\n}\n\n.teams-pagination span {\n    color: #364C63;\n    font-size: 0.95rem;\n    font-weight: 800;\n    background: #f8fafc;\n    border: 1px solid rgba(54, 76, 99, 0.1);\n    border-radius: 7px;\n    box-shadow: none;\n    padding: 5px 10px;\n}\n\n.team-actions {\n    display: flex;\n    gap: 10px;\n    margin-top: 15px;\n    justify-content: flex-end;\n}\n\n.team-actions button {\n    padding: 7px 12px;\n    border: none;\n    border-radius: 7px;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 800;\n    transition: transform 160ms ease, filter 160ms ease;\n}\n\n.team-actions button:first-child {\n    background: #24516f;\n    color: white;\n}\n\n.team-actions button:first-child:hover {\n    filter: brightness(1.06);\n    transform: translateY(-1px);\n}\n\n.team-actions button:last-child {\n    background-color: #e74c3c;\n    color: white;\n}\n\n.team-actions button:last-child:hover {\n    filter: brightness(1.04);\n    transform: translateY(-1px);\n}\n\n.team-actions button:active {\n    transform: scale(0.98);\n}\n\n@media (max-width: 768px) {\n    .center-container {\n        padding: 1rem;\n    }\n\n    .form-row {\n        flex-direction: column;\n        gap: 0.5rem;\n    }\n\n    .cards-container {\n        grid-template-columns: 1fr;\n    }\n\n    .section {\n        padding: 1rem;\n    }\n}\n\n.ass-section {\n    background-color: #ffffff;\n    border-radius: 8px;\n    margin-top: 2rem;\n    border: 1px solid rgba(54, 76, 99, 0.1);\n    box-shadow: 0 14px 34px rgba(54, 76, 99, 0.1);\n    padding: 14px;\n}\n\n.create-team-headingg {\n    color: #243447;\n    font-size: 1.2rem;\n    font-weight: 900;\n    text-transform: uppercase;\n    margin-top: 0;\n    position: relative;\n    padding-bottom: 9px;\n}\n\n.team-limit-warning {\n    background-color: #fff3cd;\n    color: #856404;\n    padding: 10px 15px;\n    border: 1px solid #ffeeba;\n    border-radius: 4px;\n    margin: 10px 0;\n    text-align: center;\n    font-weight: 500;\n}\n\n.button-containerr {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n}\n\n.button-containerr .create-button {\n    background-color: #3498db;\n    color: white;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.3s;\n}\n\n.button-containerr .create-button:hover {\n    background-color: #45a049;\n}\n\n.add-associate-buttonnn{\n    background-color: #EF6F53;\n    color: white;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background-color 0.3s;\n    border-radius: 10px;\n}\n\n.add-associate-buttonnn:hover {\n    background-color: #d15846;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
